import { getRoot } from 'mobx-easy';
import { observer } from 'mobx-react';

import { useRouteTrailer } from '../../hooks/use-route-trailer';
import { DetailedCellProps } from '../hooks/use-columns';
import RootStore from 'bringg-web/stores/root-store';

const TrailerCell = ({ row }: DetailedCellProps) => {
	const route = getRoot<RootStore>().data.runStore.get(row.data.id);
	const { trailerName } = useRouteTrailer(route);
	if (!route) {
		return null;
	}

	return <span data-test-id={`trailer-cell-${route.id}`}>{trailerName}</span>;
};

export default observer(TrailerCell);
